(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.block-accordion[data-open-first]').forEach(acc => {
    const first = acc.querySelector('details');
    if (first && !first.hasAttribute('open')) first.setAttribute('open', '');
  });

  document.querySelectorAll('.block-accordion[data-single-open]').forEach(acc => {
    acc.addEventListener('toggle', (e) => {
      if (e.target.tagName !== 'DETAILS' || !e.target.open) return;
      for (const details of acc.querySelectorAll('details[open]')) {
        if (details !== e.target) details.removeAttribute('open');
      }
    }, true);
  });
  } catch(e) { console.error(e); }
})();

})();
